import { render } from "./checkValue.vue?vue&type=template&id=c0bfa63c&scoped=true"
import script from "./checkValue.vue?vue&type=script&lang=js"
export * from "./checkValue.vue?vue&type=script&lang=js"

import "./checkValue.vue?vue&type=style&index=0&id=c0bfa63c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0bfa63c"]])

export default __exports__